import { isNumber } from 'lodash';

export function getColor(id) {
  switch (id) {
    case 0:
      return 'success';
    case 2:
      return 'error';
    case 1:
      return 'warning';
  }
}

export const getValue = (v) => v?.value;
export const getPercentValue = (v) => v?.percentValue;
export const getCompareValue = (v) => v?.compareValue;
export const getComparePercentValue = (v) => v?.comparePercentValue;
export const getDifferenceValue = (v) => v?.difference;
export const getValueColor = (v) => getColor(v?.color);
export const getCompareValueColor = (v) => getColor(v?.compareColor);

export function isSafeRow(row) {
  return row?.id !== undefined;
}

function getPercent(value, total) {
  return (100 * value) / total;
}

export function addPercentValue(metricValue, metricTotals) {
  return {
    ...metricValue,
    ...(isNumber(metricValue.value)
      ? { percentValue: getPercent(metricValue.value, metricTotals.value) }
      : null),
    ...(isNumber(metricValue.compareValue)
      ? {
          comparePercentValue: getPercent(
            metricValue.compareValue,
            metricTotals.compareValue
          ),
        }
      : null),
  };
}

export function getPercentageDecorationModel(percentageColumns = []) {
  return {
    ...percentageColumns.reduce((m, col) => {
      return {
        ...m,
        [col]: function ({ value, row, api }) {
          let totalRow;
          if (isSafeRow(row) && !row.isTotalValue) {
            const totalId = row.id.replace(row.Dimension.id, 'Totals');
            totalRow = api.getRow(totalId);
            if (!totalRow) {
              const rowNode = api.getRowNode(row.id);
              if (rowNode) {
                totalRow = api.getRow(rowNode.parent);
              }
            }
          }

          return isSafeRow(totalRow)
            ? addPercentValue(value, totalRow[col])
            : value;
        },
      };
    }, {}),
  };
}
